import apiService from './api.service';
import type { Certificate, CertificateVerification } from '@/types/certificate';

class CertificateService {
  async generate(trailId: string): Promise<Certificate> {
    const response = await apiService.post<Certificate>(
      `/trails/certificates/generate/${trailId}/`
    );
    return response.data;
  }

  async list(): Promise<Certificate[]> {
    const response = await apiService.get<{ results: Certificate[] } | Certificate[]>('/trails/certificates/');
    const data = response.data;
    return Array.isArray(data) ? data : data.results;
  }

  async getDownloadUrl(certificateId: string): Promise<string> {
    const response = await apiService.get<{ download_url: string }>(
      `/trails/certificates/${certificateId}/download/`
    );
    return response.data.download_url;
  }

  async verify(verificationCode: string): Promise<CertificateVerification> {
    const response = await apiService.get<CertificateVerification>(
      `/certificates/verify/${verificationCode}/`
    );
    return response.data;
  }
}

export const certificateService = new CertificateService();
